/**
 * @generated SignedSource<<2b55c319f3099df832fef7a2a7ebf2fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SaveBaselineAsTemplateInput = {
  projectId: string;
  name: string;
  description?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type SaveBaselineAsTemplateMutation$variables = {
  input: SaveBaselineAsTemplateInput;
};
export type SaveBaselineAsTemplateMutation$data = {
  readonly saveBaselineAsTemplate: {
    readonly baselineTemplate: {
      readonly id: string;
      readonly name: string | null;
    } | null;
    readonly company: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"BaselineTemplatesList_company">;
    } | null;
  } | null;
};
export type SaveBaselineAsTemplateMutation = {
  variables: SaveBaselineAsTemplateMutation$variables;
  response: SaveBaselineAsTemplateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "BaselineTemplate",
  "kind": "LinkedField",
  "name": "baselineTemplate",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SaveBaselineAsTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SaveBaselineAsTemplatePayload",
        "kind": "LinkedField",
        "name": "saveBaselineAsTemplate",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BaselineTemplatesList_company"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SaveBaselineAsTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SaveBaselineAsTemplatePayload",
        "kind": "LinkedField",
        "name": "saveBaselineAsTemplate",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BaselineTemplate",
                "kind": "LinkedField",
                "name": "baselineTemplates",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includeDeliverables",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "active",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "usageCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "phaseCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deliverableCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "roleCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expenseLineCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Person",
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fullName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "23fe224f724ddec7457da0cfce9dc3c6",
    "id": null,
    "metadata": {},
    "name": "SaveBaselineAsTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation SaveBaselineAsTemplateMutation(\n  $input: SaveBaselineAsTemplateInput!\n) {\n  saveBaselineAsTemplate(input: $input) {\n    baselineTemplate {\n      id\n      name\n    }\n    company {\n      id\n      ...BaselineTemplatesList_company\n    }\n  }\n}\n\nfragment BaselineTemplatesList_company on Company {\n  baselineTemplates {\n    id\n    name\n    description\n    includeDeliverables\n    active\n    usageCount\n    phaseCount\n    deliverableCount\n    totalMinutes\n    roleCount\n    expenseLineCount\n    updatedAt\n    createdBy {\n      id\n      fullName\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d7a1d4dead4e7beccd6e973aa6b2e662";

export default node;
